export const PATCH_SECURITY_OPTION = '@@myDevices/patchSecurityOption'
